import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import decode from "jwt-decode";
import { createHttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { ApolloLink } from "apollo-link";
import useLogout from "utils/hooks/useLogout";
import { useLocation } from "react-router-dom";

const cache = new InMemoryCache();

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_BACKEND_URL}/graphql`
});

const ApolloWrapper = ({ children }) => {
  const location = useLocation();

  const enhancedLogout = () => {
    const currentLocation = location.pathname + location.search;
    return logout(currentLocation);
  };

  const authMiddleware = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem("jwt");
    if (!token) {
      return enhancedLogout();
    }
    const currentTime = Date.now().valueOf() / 1000;
    let decodedToken;
    try {
      decodedToken = decode(token);
    } catch (err) {
      return enhancedLogout();
    }
    const tokenExpiration = decodedToken.exp;
    if (currentTime > tokenExpiration) {
      return enhancedLogout();
    }

    const bearerToken = `Bearer ${token}`;

    operation.setContext({
      headers: {
        authorization: bearerToken,
        jwtauth: bearerToken
      }
    });

    return forward(operation);
  });

  const errorLink = onError(({ graphQLErrors, networkError }) => {
    console.log("status code", networkError);
    if (networkError && networkError.statusCode === 403) {
      return enhancedLogout();
    }
    // if (graphQLErrors && graphQLErrors.filter(e => e).length > 0) {
    //   graphQLErrors.map(({ message = '', status = 200 }) => {
    //     if (UNAUTHORIZED === message || status === 401) {
    //       console.warn(`You've attempted to access ${UNAUTHORIZED} section`);
    //       if (
    //         history
    //       && history.location
    //       && history.location.pathname !== '/login'
    //       ) {
    //         history.push('/login');
    //       }
    //     }
    //     if (FORBIDDEN === message || status === 403) {
    //       console.warn(`You've attempted a ${FORBIDDEN} action`);
    //       history.push('/error-page/403');
    //     }
    //     return null;
    //   });
    // }
    // if (networkError && networkError.statusCode === 401) {
    //   history.push('/login');
    // }

    // if (networkError && networkError.statusCode >= 500) {
    //   console.warn('SERVER ERROR');
    //   history.push(`/error-page/${networkError.statusCode}`);
    // }
  });

  const link = ApolloLink.from([errorLink, authMiddleware, httpLink]);

  const client = new ApolloClient({
    link,
    cache
  });

  const logout = useLogout({ apolloClient: client });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloWrapper;
